import { render } from "./ApplicationMGListKaunetComponent.vue?vue&type=template&id=0b049e26&scoped=true&ts=true"
import script from "./ApplicationMGListKaunetComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationMGListKaunetComponent.vue?vue&type=script&lang=ts"

import "./ApplicationMGListKaunetComponent.vue?vue&type=style&index=0&id=0b049e26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b049e26"]])

export default __exports__